export const SERVICE_LINKS = [
  { label: "Cosmetic Formulation", path: "/cosmetic-formulation-development" },
  { label: "Skincare Formulation", path: "/skincare-formulation-development" },
  { label: "Haircare Formulation", path: "/haircare-formulation-development" },
  { label: "Wellness Product Development", path: "/wellness-product-development" },
  { label: "Private Label Cosmetics India", path: "/private-label-cosmetics-india" },
  { label: "Manufacturing Support", path: "/cosmetic-manufacturing-support" },
  { label: "Regulatory & Testing Support", path: "/regulatory-testing-support" },
];

export const COMPANY_LINKS = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "All Services", path: "/services" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export const linkLabel = (path) => [...SERVICE_LINKS, ...COMPANY_LINKS].find((l) => l.path === path)?.label || path;
